module.exports = __webpack_public_path__ + "static/media/the_boys_comp.df08c16d.jpg";